import { render, staticRenderFns } from "./advisories.vue?vue&type=template&id=97a58d5a&scoped=true"
import script from "./advisories.vue?vue&type=script&lang=js"
export * from "./advisories.vue?vue&type=script&lang=js"
import style0 from "./advisories.vue?vue&type=style&index=0&id=97a58d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a58d5a",
  null
  
)

export default component.exports